<div style="position: fixed; top: 50px; left: 0; height: 100vh; width: 260px; background-color: #000000ec; padding: 1.5rem; box-sizing: border-box; overflow-y: auto;">
    <app-global-filter [config]="filters"></app-global-filter>
    <!-- <div style="display: flex;align-items: center;color: #fff;gap:4px;">
    <a href="#">help</a><mat-icon class="icon">help</mat-icon>
    </div> -->

     <button
      mat-icon-button
      class="transparent-icon-button"
      title="Help"
      (click)="openHelpPdf()"
    >
      <mat-icon class="icon">help</mat-icon>
    </button>
   
</div>

    